import { PressEvent } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import Button from '~/components/buttons/NewButton';
import IconButton from '~/components/buttons/NewIconButton';
import Text from '~/components/typographies/Text';
import IconCheck from '~/icons/icon-check.svg?react';
import IconClose from '~/icons/icon-close.svg?react';
import IconEdit from '~/icons/icon-edit.svg?react';
import IconSplit from '~/icons/icon-split.svg?react';
import IconUnlink from '~/icons/icon-unlink.svg?react';

export const AcceptButton = ({ onClick, disabled }: { onClick?: (e: PressEvent) => void; disabled?: boolean }) => {
  return (
    <IconButton disabled={disabled} onClick={onClick} Icon={IconCheck} size="small" action="confirm" type="submit" />
  );
};

export const CloseButton = ({ onClick }: { onClick?: (e: PressEvent) => void }) => {
  return <IconButton onClick={onClick} Icon={IconClose} action="destructive" size="small" />;
};

export const EditButton = ({ onClick, disabled }: { onClick?: () => void; disabled?: boolean }) => {
  const { t } = useTranslation('reconciliations');

  return (
    <Button Icon={IconEdit} onClick={onClick} disabled={disabled} variant="link">
      <Text variant="body2" weight="semibold">
        {t('edit')}
      </Text>
    </Button>
  );
};

export const SplitButton = ({ onClick, disabled }: { onClick?: () => void; disabled?: boolean }) => {
  const { t } = useTranslation('reconciliations');

  return (
    <Button Icon={IconSplit} onClick={onClick} disabled={disabled} variant="link">
      <Text variant="body2" weight="semibold">
        {t('split')}
      </Text>
    </Button>
  );
};

export const DissociateButton = ({ onClick, disabled }: { onClick?: () => void; disabled?: boolean }) => {
  const { t } = useTranslation('reconciliations');

  return (
    <Button disabled={disabled} Icon={IconUnlink} onClick={onClick} variant="link">
      <Text variant="body2" weight="semibold">
        {t('dissociate')}
      </Text>
    </Button>
  );
};
